import { Linking } from 'react-native';

export const handleTermsOfServicePress = () => {
  Linking.openURL('https://socrait.com/termsofservice/');
};

export const handlePrivacyPolicyPress = () => {
  Linking.openURL('https://socrait.com/socrait-privacy-notice/');
};

export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.socrait.mobile';
export const IOS_APP_URL = 'https://apps.apple.com/us/app/socrait/id6744591167';

export const openAndroidAppStore = () => {
  Linking.openURL(ANDROID_APP_URL);
};

export const openIosAppStore = () => {
  Linking.openURL(IOS_APP_URL);
};

export const SMALL_SCREEN_WIDTH = 768;
